// extracted by mini-css-extract-plugin
module.exports = {"sunny_header":"header_sunny_header__2SFaQ","headerFixed":"header_headerFixed__2LB4p"};